// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"b","newsroomBannerBox":"b","newsroomBannerLeft":"c","newsroomBannerRight":"d"};